const NavigationButtons = ({ goBack, submit }) => {
  return (
    <>
      <div className="d-flex justify-content-center">
        <button
          className="new-investor-button"
          onClick={goBack}
          disabled={!goBack}
          style={{ border: "1px solid #007ac8", color: "#007ac8" }}
        >
          Back
        </button>
        <button
          className="new-investor-button new-investor-active"
          onClick={submit}
        >
          Proceed
        </button>
      </div>
    </>
  );
};

export default NavigationButtons;
